export enum CompanyEquipmentType {
  LAPTOP = "Laptop",
  MOBILE_PHONE = "Gsm",
  COMPANY_CAR = "Bedrijfswagen",
}

export const EQUIPMENT_TYPE_LABELS: Record<CompanyEquipmentType, string> = {
  [CompanyEquipmentType.LAPTOP]: "Laptop",
  [CompanyEquipmentType.MOBILE_PHONE]: "Gsm",
  [CompanyEquipmentType.COMPANY_CAR]: "Bedrijfswagen",
};

export const EQUIPMENT_TYPE_COLORS: Record<CompanyEquipmentType, string> = {
  [CompanyEquipmentType.LAPTOP]: "bg-moss-secondary-light text-moss-primary",
  [CompanyEquipmentType.MOBILE_PHONE]: "bg-brick-secondary-light text-brick-primary",
  [CompanyEquipmentType.COMPANY_CAR]: "bg-yellow-secondary-light text-yellow-primary",
};

export interface CompanyEquipment {
  id: number;
  companyId: string;
  companyName: string;
  companyEquipmentType: CompanyEquipmentType | null;
  serialNumber: string;
  inUseBy: string | null;
}
